import React from 'react';

function Footer(props) {
    return (
        <div id='footer'>
            <h2>Thank you for visiting this site</h2>
            <pre>Created by   :   '{props.owner}'</pre>
            <p>asadalimehar777@gmail.com</p>
            <div className="icons">
            <a href={props.linkfb}  target="_blank"> <i className="fa-brands fa-lg fa-facebook"></i> </a>
            <a href={props.linkwa} target="_blank"> <i className="fa-brands fa-lg fa-whatsapp"></i> </a>
            <a href={props.linkmess} target="_blank"> <i className="fa-brands fa-lg fa-facebook-messenger"></i> </a>
            <a href={props.linkemail} target="_blank"> <i className="fa-solid fa-lg fa-envelope"></i> </a>
            </div>
        </div>
    );
}
export default Footer;
